import LabelAndDescription from "../../LabelAndDescription";

export default function ListOfInformation(props: {labels: string[], contents: any[]}): JSX.Element {
    return <>
        {props.labels.map((l, i) => <LabelAndDescription alternate={true} label={l} 
            description={props.contents[i]} key={i} />)}
    </>
}